import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ApiService} from '../../../../utils/services/api.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class OrganizationResolverService implements Resolve<any> {

  constructor(private apiService: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let organizationID = route.params.id || route.parent.params.id;

    return this.apiService.getOrganizationByID(organizationID).map(
      response => {
        return response['data'];
      }
    ).catch((error) => {
      return Observable.of(null);
    });
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/organization-detail/resolvers/organization-resolver.service.ts